import { useState, useEffect, useCallback, useRef } from "react";
import Footer from "../../components/shared/Footer";
import AttorneySelect from "../../components/shared/AttorneySelect";
import AttachExhibits from "./components/AttachExhibits";
import NewCaseDocuments from "./components/NewCaseDocuments";
import NewCaseEFileSummary from "./components/NewCaseEFileSummary";
import NewCaseInformationPanel from "./components/NewCaseInformationPanel";

import { OrganizationService } from "../../services/ClientService";
import { Globals } from "../../helpers/globals";

import * as APIModels from "../../models";

import { useParams } from "react-router-dom";
import {
    SubmissionService,
    eFileService,
} from "../../services/SubmissionService";
import React from "react";

export default function TemplateNewCase() {
    const { id } = useParams<{ id: string }>();
    const [eFileUpload, seteFileUpload] = useState(
        null as APIModels.UploadNewCase | null
    );
    const [addExhibit, setAddExhibits] = useState(null as null | boolean);

    const [loading, setLoading] = useState(true);
    const [time, setTime] = useState(Date.now);
    const [documentCheck, setDocumentCheck] = useState(false);

    const [emergencyFiling, setEmergencyFiling] = useState(false);

    const coverSheetNext = useRef<HTMLButtonElement>(null);

    const currentUser = Globals.currentUserValue;

    const [organization, setOrganization] = useState(
        new APIModels.Organization()
    );

    useEffect(() => {
        OrganizationService.get({
            id: currentUser.organizationID ?? "",
        }).then((resp) => {
            if (resp) {
                setOrganization(resp!.data!);
            }
        });
        eFileService.get({ id: id }).then(
            (resp) => {
                setLoading(false);
                if (resp.successful && resp.data) {
                    //show efile success
                    seteFileUpload({
                        ...resp.data,
                        documents: resp.data.filenames?.map((v) => {
                            return { filename: v, documentType: "" };
                        }),
                    });
                } else {
                    //TODO: Show error
                }
            },
            (error) => {
                setLoading(false);
                console.log(error);
            }
        );
    }, []);

    useEffect(() => {
        if (eFileUpload) {
            eval(
                "$('#checkout-nav-pills-wizard').bootstrapWizard({tabClass: 'nav nav-pills nav-justified'});"
            );
        }
    }, [eFileUpload, addExhibit]);

    const onAttorneySelected = (id: string, name: string) => {
        if (eFileUpload === null) {
            seteFileUpload({ attorneyID: id, attorneyName: name });
        } else {
            seteFileUpload({
                ...eFileUpload,
                attorneyID: id,
                attorneyName: name,
            });
        }
    };
    const onFirmSelected = (id: string, name: string) => {
        seteFileUpload({ ...eFileUpload, attorneyID: "", attorneyName: "" });
        console.log(eFileUpload);
    };

    const onFinishedExhibits = (exhibits: APIModels.Exhibits) => {
        seteFileUpload({ ...eFileUpload, exhibits: exhibits });
    };

    const onClickAddExhibits = () => {
        setAddExhibits(true);
    };

    const onClickNoExhibits = () => {
        setAddExhibits(false);
        if (eFileUpload?.exhibits) {
            const temp = { ...eFileUpload };
            delete temp.exhibits;
            seteFileUpload(temp);
        }
    };

    useEffect(() => {
        /*
        seteFileUpload({
            ...eFileUpload,
        });
        */
    }, [emergencyFiling]);

    const onSubmit = () => {
        SubmissionService.uploadNewCase({
            id: id,
            body: eFileUpload!,
        }).then(
            (resp) => {
                console.log(resp);
                if (resp.successful && resp.data) {
                    //show efile success
                    window.location.href = "/uploads";
                } else {
                    //TODO: Show error
                }
            },
            (error) => {
                console.log(error);
            }
        );
    };

    const onCoversheetComplete = (completeCoversheet: APIModels.Coversheet) => {
        seteFileUpload({ ...eFileUpload, coversheet: completeCoversheet });
        setTime(Date.now);
    };

    useEffect(() => {
        if (eFileUpload?.coversheet) {
            coverSheetNext.current?.click();
        }
    }, [eFileUpload?.coversheet, coverSheetNext, time]);

    return (
        <div className="content">
            <div className="container-fluid">
                <div className="row">
                    <div className="col-12">
                        <div className="page-title-box page-title-box-alt">
                            <h4 className="page-title">Uploads</h4>
                            <div className="page-title-right">
                                <ol className="breadcrumb m-0">
                                    <li className="breadcrumb-item">
                                        <a href="javascript: void(0);">
                                            eFileMadeEasy
                                        </a>
                                    </li>
                                    <li className="breadcrumb-item">
                                        <a href="javascript: void(0);">eFile</a>
                                    </li>
                                    <li className="breadcrumb-item active">
                                        Template New Case
                                    </li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </div>
                {loading === true ||
                organization.templateOnly === undefined ||
                organization.templateOnly === null ? (
                    <div
                        style={{
                            height: "400px",
                            textAlign: "center",
                            paddingTop: "180px",
                        }}
                    >
                        <span
                            className="spinner-border spinner-border-lg me-1"
                            role="status"
                            aria-hidden="true"
                        ></span>
                    </div>
                ) : (
                    <>
                        {organization.templateOnly === false ? (
                            <div className="row">
                                <div className="col-12">
                                    <div className="card">
                                        <div className="card-body">
                                            <div className="row">
                                                <div className="col-xl-12">
                                                    <>
                                                        <div
                                                            id="checkout-nav-pills-wizard"
                                                            className="twitter-bs-wizard form-wizard-header"
                                                        >
                                                            <ul className="twitter-bs-wizard-nav mb-2 nav nav-pills nav-justified">
                                                                <li className="nav-item">
                                                                    <a
                                                                        href="#attorney-info"
                                                                        className="nav-link active"
                                                                        style={{
                                                                            pointerEvents:
                                                                                "none",
                                                                        }}
                                                                        data-bs-toggle="tab"
                                                                        data-toggle="tab"
                                                                    >
                                                                        <span className="number">
                                                                            01
                                                                        </span>
                                                                        <span className="d-none d-sm-inline">
                                                                            Attorney
                                                                        </span>
                                                                    </a>
                                                                </li>

                                                                <li className="nav-item">
                                                                    <a
                                                                        href="#coversheet"
                                                                        className="nav-link"
                                                                        data-bs-toggle="tab"
                                                                        data-toggle="tab"
                                                                        style={{
                                                                            pointerEvents:
                                                                                "none",
                                                                        }}
                                                                    >
                                                                        <span className="number">
                                                                            02
                                                                        </span>
                                                                        <span className="d-none d-sm-inline">
                                                                            Case
                                                                            Information
                                                                        </span>
                                                                    </a>
                                                                </li>
                                                                <li className="nav-item">
                                                                    <a
                                                                        className="nav-link"
                                                                        href="#exhibit-info"
                                                                        style={{
                                                                            pointerEvents:
                                                                                "none",
                                                                        }}
                                                                        data-bs-toggle="tab"
                                                                        data-toggle="tab"
                                                                    >
                                                                        <span className="number">
                                                                            03
                                                                        </span>
                                                                        <span className="d-none d-sm-inline">
                                                                            Exhibits
                                                                            (Optional)
                                                                        </span>
                                                                    </a>
                                                                </li>
                                                                <li className="nav-item">
                                                                    <a
                                                                        className="nav-link"
                                                                        href="#summary"
                                                                        style={{
                                                                            pointerEvents:
                                                                                "none",
                                                                        }}
                                                                        data-bs-toggle="tab"
                                                                        data-toggle="tab"
                                                                    >
                                                                        <span className="number">
                                                                            04
                                                                        </span>
                                                                        <span className="d-none d-sm-inline">
                                                                            Summary
                                                                        </span>
                                                                    </a>
                                                                </li>
                                                            </ul>
                                                            <div className="tab-content twitter-bs-wizard-tab-content">
                                                                <div
                                                                    className="tab-pane active"
                                                                    id="attorney-info"
                                                                >
                                                                    <div>
                                                                        <h4 className="header-title">
                                                                            Attorney
                                                                            Information
                                                                        </h4>
                                                                        <p className="sub-header">
                                                                            Please
                                                                            select
                                                                            the
                                                                            attorney
                                                                            that
                                                                            is
                                                                            filing
                                                                            this(these)
                                                                            pleadings.
                                                                        </p>
                                                                    </div>
                                                                    <AttorneySelect
                                                                        onAttorneySelected={
                                                                            onAttorneySelected
                                                                        }
                                                                        onFirmSelected={
                                                                            onFirmSelected
                                                                        }
                                                                    />
                                                                    <ul className="pager wizard list-inline mt-2">
                                                                        <li className="list-inline-item">
                                                                            <a
                                                                                href="/uploads"
                                                                                className="btn btn-secondary"
                                                                            >
                                                                                <i className="mdi mdi-arrow-left"></i>{" "}
                                                                                Back
                                                                                to
                                                                                Upload
                                                                            </a>
                                                                        </li>
                                                                        <li
                                                                            className="next list-inline-item float-end"
                                                                            style={{
                                                                                pointerEvents:
                                                                                    eFileUpload?.attorneyID
                                                                                        ? "auto"
                                                                                        : "none",
                                                                            }}
                                                                        >
                                                                            {!eFileUpload?.attorneyID ||
                                                                            eFileUpload?.attorneyID ==
                                                                                "" ? (
                                                                                <button
                                                                                    type="button"
                                                                                    className="btn btn-success disabled"
                                                                                    disabled
                                                                                >
                                                                                    Next
                                                                                    <i className="mdi mdi-arrow-right"></i>{" "}
                                                                                </button>
                                                                            ) : (
                                                                                <button
                                                                                    type="button"
                                                                                    className="btn btn-success"
                                                                                >
                                                                                    Next
                                                                                    <i className="mdi mdi-arrow-right"></i>{" "}
                                                                                </button>
                                                                            )}
                                                                        </li>
                                                                    </ul>
                                                                </div>

                                                                <div
                                                                    className="tab-pane"
                                                                    id="coversheet"
                                                                >
                                                                    <NewCaseInformationPanel
                                                                        onComplete={
                                                                            onCoversheetComplete
                                                                        }
                                                                        coversheet={
                                                                            eFileUpload?.coversheet ??
                                                                            new APIModels.Coversheet()
                                                                        }
                                                                        attorneyId={
                                                                            eFileUpload?.attorneyID ??
                                                                            ""
                                                                        }
                                                                    />
                                                                    <ul className="pager wizard list-inline mt-2">
                                                                        <li className="previous list-inline-item">
                                                                            <button
                                                                                type="button"
                                                                                className="btn btn-secondary"
                                                                            >
                                                                                <i className="mdi mdi-arrow-left me-1"></i>{" "}
                                                                                Back
                                                                                to
                                                                                Attorney
                                                                            </button>
                                                                        </li>

                                                                        <li
                                                                            className="next list-inline-item float-end"
                                                                            style={{
                                                                                pointerEvents:
                                                                                    eFileUpload?.coversheet
                                                                                        ? "auto"
                                                                                        : "none",
                                                                            }}
                                                                        >
                                                                            <button
                                                                                type="button"
                                                                                className="btn btn-success"
                                                                                disabled={
                                                                                    !eFileUpload?.coversheet
                                                                                }
                                                                                ref={
                                                                                    coverSheetNext
                                                                                }
                                                                                style={{
                                                                                    display:
                                                                                        "none",
                                                                                }}
                                                                            >
                                                                                Next
                                                                                <i className="mdi mdi-arrow-right"></i>{" "}
                                                                            </button>
                                                                        </li>
                                                                    </ul>
                                                                </div>
                                                                <div
                                                                    className="tab-pane"
                                                                    id="exhibit-info"
                                                                >
                                                                    <div>
                                                                        <h4 className="header-title">
                                                                            Exhibit
                                                                        </h4>

                                                                        <p className="sub-header">
                                                                            Do
                                                                            you
                                                                            need
                                                                            to
                                                                            attach
                                                                            additional
                                                                            exhibits
                                                                            to
                                                                            your
                                                                            filing?
                                                                        </p>

                                                                        <p className="sub-header">
                                                                            EXHIBITS
                                                                            DO
                                                                            NOT
                                                                            ATTACH
                                                                            TO
                                                                            BATCH
                                                                            FILES
                                                                        </p>
                                                                    </div>
                                                                    <div className="row">
                                                                        <div className="col-12">
                                                                            <button
                                                                                type="button"
                                                                                className="btn btn-primary"
                                                                                onClick={
                                                                                    onClickAddExhibits
                                                                                }
                                                                            >
                                                                                Yes
                                                                            </button>
                                                                            &nbsp;
                                                                            <button
                                                                                type="button"
                                                                                className="btn btn-danger"
                                                                                onClick={
                                                                                    onClickNoExhibits
                                                                                }
                                                                            >
                                                                                No
                                                                            </button>
                                                                        </div>
                                                                    </div>
                                                                    <div className="row">
                                                                        <div className="col-12">
                                                                            {addExhibit && (
                                                                                <AttachExhibits
                                                                                    callback={
                                                                                        onFinishedExhibits
                                                                                    }
                                                                                />
                                                                            )}
                                                                        </div>
                                                                        <div />
                                                                    </div>
                                                                    <ul className="pager wizard list-inline mt-2">
                                                                        <li className="previous list-inline-item">
                                                                            <button
                                                                                type="button"
                                                                                className="btn btn-secondary"
                                                                            >
                                                                                <i className="mdi mdi-arrow-left me-1"></i>{" "}
                                                                                Back
                                                                                to
                                                                                Case
                                                                                Information
                                                                            </button>
                                                                        </li>
                                                                        {addExhibit ===
                                                                            false ||
                                                                        (addExhibit ==
                                                                            true &&
                                                                            eFileUpload?.exhibits !=
                                                                                undefined &&
                                                                            eFileUpload
                                                                                ?.exhibits
                                                                                .filenames!
                                                                                .length !=
                                                                                0) ? (
                                                                            <li className="next list-inline-item float-end">
                                                                                <button
                                                                                    type="button"
                                                                                    className="btn btn-success"
                                                                                >
                                                                                    Next
                                                                                    <i className="mdi mdi-arrow-right"></i>{" "}
                                                                                </button>
                                                                            </li>
                                                                        ) : (
                                                                            <li
                                                                                className="next list-inline-item float-end"
                                                                                style={{
                                                                                    pointerEvents:
                                                                                        "none",
                                                                                }}
                                                                            >
                                                                                <button
                                                                                    type="button"
                                                                                    className="btn btn-success disabled"
                                                                                    disabled={
                                                                                        true
                                                                                    }
                                                                                >
                                                                                    Next
                                                                                    <i className="mdi mdi-arrow-right"></i>{" "}
                                                                                </button>
                                                                            </li>
                                                                        )}
                                                                    </ul>
                                                                </div>
                                                                <div
                                                                    className="tab-pane"
                                                                    id="summary"
                                                                >
                                                                    <div>
                                                                        <h4 className="header-title">
                                                                            Summary
                                                                        </h4>
                                                                        <p className="sub-header">
                                                                            Review
                                                                            the
                                                                            information
                                                                            below
                                                                            and
                                                                            verify
                                                                            for
                                                                            accuracy.
                                                                        </p>
                                                                    </div>
                                                                    <div>
                                                                        {" "}
                                                                        <NewCaseEFileSummary
                                                                            upload={
                                                                                eFileUpload ??
                                                                                {}
                                                                            }
                                                                        />
                                                                    </div>
                                                                    <ul className="pager wizard list-inline mt-2">
                                                                        <li className="previous list-inline-item">
                                                                            <button
                                                                                type="button"
                                                                                className="btn btn-secondary"
                                                                            >
                                                                                <i className="mdi mdi-arrow-left me-1"></i>{" "}
                                                                                Back
                                                                                to
                                                                                Coversheet
                                                                            </button>
                                                                        </li>

                                                                        <li
                                                                            className="next list-inline-item"
                                                                            style={{
                                                                                position:
                                                                                    "relative",

                                                                                left: "80%",
                                                                            }}
                                                                        >
                                                                            <button
                                                                                type="button"
                                                                                className="btn btn-success"
                                                                                onClick={
                                                                                    onSubmit
                                                                                }
                                                                            >
                                                                                Submit
                                                                                <i className="mdi mdi-arrow-right"></i>{" "}
                                                                            </button>
                                                                        </li>
                                                                    </ul>
                                                                    <div
                                                                        className="form-check"
                                                                        style={{
                                                                            position:
                                                                                "relative",

                                                                            top: "50%",
                                                                            left: "92%",
                                                                            wordBreak:
                                                                                "break-word",
                                                                            whiteSpace:
                                                                                "break-spaces",
                                                                            maxWidth:
                                                                                "150px",
                                                                        }}
                                                                    >
                                                                        <input
                                                                            className="form-check-input"
                                                                            id="ckEmergency"
                                                                            type="checkbox"
                                                                            checked={
                                                                                emergencyFiling
                                                                            }
                                                                            onChange={(
                                                                                event
                                                                            ) =>
                                                                                setEmergencyFiling(
                                                                                    event
                                                                                        .currentTarget
                                                                                        .checked
                                                                                )
                                                                            }
                                                                        />
                                                                        <label
                                                                            className="form-check-label"
                                                                            htmlFor="ckOverride"
                                                                        >
                                                                            Is
                                                                            this
                                                                            an
                                                                            Emergency
                                                                            Filing?
                                                                        </label>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ) : (
                            <div className="row">
                                <div className="col-12">
                                    <div className="card">
                                        <div className="card-body">
                                            <div className="row">
                                                <div className="col-xl-12">
                                                    <>
                                                        <div
                                                            id="checkout-nav-pills-wizard"
                                                            className="twitter-bs-wizard form-wizard-header"
                                                        >
                                                            <ul className="twitter-bs-wizard-nav mb-2 nav nav-pills nav-justified">
                                                                <li className="nav-item">
                                                                    <a
                                                                        href="#attorney-info"
                                                                        className="nav-link active"
                                                                        style={{
                                                                            pointerEvents:
                                                                                "none",
                                                                        }}
                                                                        data-bs-toggle="tab"
                                                                        data-toggle="tab"
                                                                    >
                                                                        <span className="number">
                                                                            01
                                                                        </span>
                                                                        <span className="d-none d-sm-inline">
                                                                            Attorney
                                                                        </span>
                                                                    </a>
                                                                </li>

                                                                <li className="nav-item">
                                                                    <a
                                                                        className="nav-link"
                                                                        href="#summary"
                                                                        style={{
                                                                            pointerEvents:
                                                                                "none",
                                                                        }}
                                                                        data-bs-toggle="tab"
                                                                        data-toggle="tab"
                                                                    >
                                                                        <span className="number">
                                                                            02
                                                                        </span>
                                                                        <span className="d-none d-sm-inline">
                                                                            Summary
                                                                        </span>
                                                                    </a>
                                                                </li>
                                                            </ul>
                                                            <div className="tab-content twitter-bs-wizard-tab-content">
                                                                <div
                                                                    className="tab-pane active"
                                                                    id="attorney-info"
                                                                >
                                                                    <div>
                                                                        <h4 className="header-title">
                                                                            Attorney
                                                                            Information
                                                                        </h4>
                                                                        <p className="sub-header">
                                                                            Please
                                                                            select
                                                                            the
                                                                            attorney
                                                                            that
                                                                            is
                                                                            filing
                                                                            this(these)
                                                                            pleadings.
                                                                        </p>
                                                                    </div>
                                                                    <AttorneySelect
                                                                        onAttorneySelected={
                                                                            onAttorneySelected
                                                                        }
                                                                        onFirmSelected={
                                                                            onFirmSelected
                                                                        }
                                                                    />
                                                                    <ul className="pager wizard list-inline mt-2">
                                                                        <li className="list-inline-item">
                                                                            <a
                                                                                href="/uploads"
                                                                                className="btn btn-secondary"
                                                                            >
                                                                                <i className="mdi mdi-arrow-left"></i>{" "}
                                                                                Back
                                                                                to
                                                                                Upload
                                                                            </a>
                                                                        </li>
                                                                        <li
                                                                            className="next list-inline-item float-end"
                                                                            style={{
                                                                                pointerEvents:
                                                                                    eFileUpload?.attorneyID
                                                                                        ? "auto"
                                                                                        : "none",
                                                                            }}
                                                                        >
                                                                            {!eFileUpload?.attorneyID ||
                                                                            eFileUpload?.attorneyID ==
                                                                                "" ? (
                                                                                <button
                                                                                    type="button"
                                                                                    className="btn btn-success disabled"
                                                                                    disabled
                                                                                >
                                                                                    Next
                                                                                    <i className="mdi mdi-arrow-right"></i>{" "}
                                                                                </button>
                                                                            ) : (
                                                                                <button
                                                                                    type="button"
                                                                                    className="btn btn-success"
                                                                                >
                                                                                    Next
                                                                                    <i className="mdi mdi-arrow-right"></i>{" "}
                                                                                </button>
                                                                            )}
                                                                        </li>
                                                                    </ul>
                                                                </div>
                                                                <div
                                                                    className="tab-pane"
                                                                    id="summary"
                                                                >
                                                                    <div>
                                                                        <h4 className="header-title">
                                                                            Summary
                                                                        </h4>
                                                                        <p className="sub-header">
                                                                            Review
                                                                            the
                                                                            information
                                                                            below
                                                                            and
                                                                            verify
                                                                            for
                                                                            accuracy.
                                                                        </p>
                                                                    </div>
                                                                    <div>
                                                                        {" "}
                                                                        <NewCaseEFileSummary
                                                                            upload={
                                                                                eFileUpload ??
                                                                                {}
                                                                            }
                                                                        />
                                                                    </div>
                                                                    <ul className="pager wizard list-inline mt-2">
                                                                        <li className="previous list-inline-item">
                                                                            <button
                                                                                type="button"
                                                                                className="btn btn-secondary"
                                                                            >
                                                                                <i className="mdi mdi-arrow-left me-1"></i>{" "}
                                                                                Back
                                                                                to
                                                                                Attorney
                                                                            </button>
                                                                        </li>

                                                                        <li
                                                                            className="next list-inline-item"
                                                                            style={{
                                                                                position:
                                                                                    "relative",

                                                                                left: "80%",
                                                                            }}
                                                                        >
                                                                            <button
                                                                                type="button"
                                                                                className="btn btn-success"
                                                                                onClick={
                                                                                    onSubmit
                                                                                }
                                                                            >
                                                                                Submit
                                                                                <i className="mdi mdi-arrow-right"></i>{" "}
                                                                            </button>
                                                                        </li>
                                                                    </ul>
                                                                    <div
                                                                        className="form-check"
                                                                        style={{
                                                                            position:
                                                                                "relative",

                                                                            top: "50%",
                                                                            left: "92%",
                                                                            wordBreak:
                                                                                "break-word",
                                                                            whiteSpace:
                                                                                "break-spaces",
                                                                            maxWidth:
                                                                                "150px",
                                                                        }}
                                                                    >
                                                                        <input
                                                                            className="form-check-input"
                                                                            id="ckEmergency"
                                                                            type="checkbox"
                                                                            checked={
                                                                                emergencyFiling
                                                                            }
                                                                            onChange={(
                                                                                event
                                                                            ) =>
                                                                                setEmergencyFiling(
                                                                                    event
                                                                                        .currentTarget
                                                                                        .checked
                                                                                )
                                                                            }
                                                                        />
                                                                        <label
                                                                            className="form-check-label"
                                                                            htmlFor="ckOverride"
                                                                        >
                                                                            Is
                                                                            this
                                                                            an
                                                                            Emergency
                                                                            Filing?
                                                                        </label>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                    </>
                )}
            </div>
            <Footer />
        </div>
    );
}
